<template>
  <div class="customer-edit-dots">
    <!-- GENERATE DIALOG-->
    <b-modal id="customer-edit-dots__dialog" ref="gendialog" class="customer-edit-dots__dialog" title="Generar Informe"
      hide-footer>
      <div class="row">
        <div class="col">
          <select v-model="doctor_id" id="customer_dot_doctor" class="custom-select form-control">
            <option :value="null">Selecciona Doctor/a</option>
            <option v-for="(doctor, index) in doctors" :key="index" :value="doctor.doctor.id">
              {{ doctor.name }}
            </option>
          </select>
          <label for="customer_dot_doctor" class="wabident-info">Doctor</label>
        </div>

        <div class="col">
          <input class="form-control" type="date" id="customer_dot_date" v-model="document_date" />
          <label for="customer_dot_date" class="wabident-info">Fecha Informe</label>
        </div>
      </div>
      <div class="form-group row mt-3">
        <div class="col text-center">
          <button @click="closeGenDialog" class="btn btn-wabident mx-3">
            Cancelar
          </button>
          <button @click="generateDocument" :disabled="!doctor_id" class="btn btn-wabident mx-3">
            Generar
          </button>
        </div>
      </div>
    </b-modal>
    <!-- MAIN EDITOR -->
    <div class="customer-edit-dots__buttons">
      <button @click="showGenDialog" class="btn btn-wabident">Generar Informe ... <i class="fas fa-print"></i></button>
      <button @click="saveDOTs" class="btn btn-wabident">Guardar <i class="fas fa-save"></i></button>
    </div>
    <div v-for="(title, section) in sections" class="container-fluid customer-edit-dots__section">
      <!-- GROUP HEADER -->
      <div class="row customer-edit-dots__header">
        <h2>{{ title }}</h2>
        <div class="d-flex align-items-center" style="gap:15px">
          <select v-if="section != 'objectives'" class="custom-select size-s" v-model="selected_groups[section]">
            <option :value="null">Elige ...</option>
            <option v-for="(name, value) in group_names[section]" :value="value">{{ name }}</option>
          </select>

          <button v-if="section != 'objectives'" @click="addDOTGroup(section)"
            class="btn btn-wabident btn-wabident-round d-flex align-items-center" :disabled="!selected_groups[section]">
            <i class="fas fa-plus"></i>&nbsp;Añadir&nbsp;Grupo
          </button>

          <button v-if="section == 'diagnostic'" @click="addAllDiags"
            class="btn btn-wabident btn-wabident-round d-flex align-items-center">
            <i class="fas fa-plus"></i>&nbsp;Añadir&nbsp;Todos
          </button>
        </div>
      </div>
      <!-- GROUP BODY -->
      <draggable v-model="dots[section]" handle=".customer-edit-dots__handle" @change="reorderDOTs(section)">
        <transition-group>
          <div :key="dot.id" v-for="dot in dots[section]" class="row customer-edit-dots__group" @click="dotClick(dot)">
            <div class="col-12">
              <button v-if="section != 'objectives'" class="btn btn-wabident-round delete small float-right"
                @click="deleteGroup(dot)">
                <i class="fas fa-trash"></i>
              </button>
              <h3 class="d-flex align-items-center" style="gap:5px">
                <div class="customer-edit-dots__handle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.20023 2.80013C8.20023 3.79431 7.39428 4.60025 6.4001 4.60025C5.40592 4.60025 4.59998 3.79431 4.59998 2.80013C4.59998 1.80594 5.40592 1 6.4001 1C7.39428 1 8.20023 1.80594 8.20023 2.80013ZM8.20023 9.99979C8.20023 10.994 7.39428 11.7999 6.4001 11.7999C5.40592 11.7999 4.59998 10.994 4.59998 9.99979C4.59998 9.00561 5.40592 8.19966 6.4001 8.19966C7.39428 8.19966 8.20023 9.00561 8.20023 9.99979ZM6.4001 19C7.39428 19 8.20023 18.1941 8.20023 17.1999C8.20023 16.2057 7.39428 15.3997 6.4001 15.3997C5.40592 15.3997 4.59998 16.2057 4.59998 17.1999C4.59998 18.1941 5.40592 19 6.4001 19ZM15.3999 2.80013C15.3999 3.79431 14.5939 4.60025 13.5998 4.60025C12.6056 4.60025 11.7996 3.79431 11.7996 2.80013C11.7996 1.80594 12.6056 1 13.5998 1C14.5939 1 15.3999 1.80594 15.3999 2.80013ZM13.5998 11.7999C14.5939 11.7999 15.3999 10.994 15.3999 9.99979C15.3999 9.00561 14.5939 8.19966 13.5998 8.19966C12.6056 8.19966 11.7996 9.00561 11.7996 9.99979C11.7996 10.994 12.6056 11.7999 13.5998 11.7999ZM15.3999 17.1999C15.3999 18.1941 14.5939 19 13.5998 19C12.6056 19 11.7996 18.1941 11.7996 17.1999C11.7996 16.2057 12.6056 15.3997 13.5998 15.3997C14.5939 15.3997 15.3999 16.2057 15.3999 17.1999Z"
                      fill="#A6AAB4"></path>
                  </svg>
                </div>
                <span v-if="section == 'objectives'">Editar Objetivos</span>
                <span v-else>{{ dot.group }}</span>
                <i class="fas fa-edit"></i>
              </h3>
            </div>
            <div class="col-12">
              <template v-if="is_editing_dot && is_editing_dot.id == dot.id">
                <textarea :id="`customer_dot_` + dot.id" class="form-control customer-edit-dots__textarea"
                  v-model="dot.content"></textarea>
                <div class="d-flex align-items-center mt-3" style="gap:15px">
                  <v-select multiple class="wabident-selector" style="flex: 1 1 auto" :options="types_for_dot"
                    placeholder="Busca el concepto aquí ..." v-model="selected_types" :searchable="true"
                    :close-on-select="false"></v-select>
                  <button @click="insertSelectedTypes(dot)"
                    class="btn btn-wabident btn-wabident-round">Insertar</button>
                </div>
              </template>
              <div class="customer-edit-dots__content" v-else v-html="dot.content">
              </div>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
        </transition-group>
      </draggable>
      <!-- END GROUP BODY -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["customer"],
  data() {
    return {
      doctor_id: null,
      document_date: null,
      selected_types: [],
      selected_groups: {
        diagnostic: null,
        objectives: null,
        treatment: null,
      },
      sections: {
        diagnostic: "DIAGNÓSTICO",
        objectives: "OBJETIVOS",
        treatment: "TRATAMIENTO",
      },
      is_editing_dot: null,
      dots: {},
      dot_types: {},
      quill_options: {
        placeholder: "Introduce texto ...",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["blockquote", "code-block", "link"],
            ["clean"],
          ],
        },
      },
    }
  },
  computed: {
    doctors() {
      if (!this.clinic) return [];
      return this.clinic.doctors.filter((d) => {
        return d.is_active || this.doctor_id == d.doctor.id || this.second_doctor_id == d.doctor.id;
      });
    },
    group_names() {
      let ret = {
        diagnostic: {},
        objectives: {},
        treatment: {},
      }

      for (const block in this.dot_types) {
        const block_groups = this.dot_types[block];
        for (const group_slug in block_groups) {
          const t = block_groups[group_slug][0];
          ret[block][group_slug] = t.group;
        }
      }

      return ret;
    },
    types_for_dot() {
      if (!this.is_editing_dot) {
        return [];
      }

      return this.getTypesForDOT(this.is_editing_dot).map((dot) => {
        return {
          label: dot.content,
          value: dot
        }
      });

    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    generateDocument() {
      this.$refs.gendialog.hide();

      const data = {
        dots: this.dots,
        doctor_id: this.doctor_id,
        document_date: this.document_date,
      };

      axios.post(`/customer/${this.customer.id}/dot_report`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        } else {
          this.msgwindow.success('Informe generado. Consulte la pestaña "Documentos" para revisarlo.');
        }
      }).catch((error) => {
        this.msgwindow.error('No puede guardar el DOT. Consulta al Administrador');
      }).then(() => {
        this.getCustomerDOTs();
      });
    },
    showGenDialog() {
      this.doctor_id = null;
      this.document_date = new Date().toISODate();
      this.$refs.gendialog.show();
    },
    closeGenDialog() {
      this.$refs.gendialog.hide();
    },
    saveDOTs() {
      const data = {
        dots: this.dots
      };

      axios.post(`/customer/${this.customer.id}/dots`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        } else {
          this.msgwindow.success('DOT Guardado');
        }
      }).catch((error) => {
        this.msgwindow.error('No puede guardar el DOT. Consulta al Administrador');
      }).then(() => {
        this.getCustomerDOTs();
      });
    },
    reorderDOTs(section) {
      var dots = this.dots[section];
      for (let i = 0; i < dots.length; i++) {
        dots[i].order = (i + 1);
      }
    },
    deleteGroup(dot) {
      this.errorwindow.show('Confirmación', '¿Deseas borrar el grupo?<b>Esta operación no se podrá deshacer</b>', 'Borrar', 'Cancelar', () => {
        this.doDeleteGroup(dot);
      });
    },
    doDeleteGroup(dot) {
      const data = {
        id: dot.id
      };

      axios.post(`/customer/${this.customer.id}/delete_dot`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        } else {
          this.msgwindow.success('Grupo Borrado');
        }
      }).catch((error) => {
        this.msgwindow.error('No pude borrar el grupo. Consulta con el Administrador');
      }).then(() => {
        this.getCustomerDOTs();
      });
    },
    addAllDiags() {
      const data = {};
      axios.post(`/customer/${this.customer.id}/add_all_diags`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        } else {
          this.msgwindow.success('Grupos Diagnósticos Añadidos');
        }
      }).catch((error) => {
        this.msgwindow.error('No pude añadir el grupo. Consulta con el Administrador');
      }).then(() => {
        this.getCustomerDOTs();
        this.selected_groups[block] = null;
      });
    },
    addDOTGroup(block) {
      const selected_group = this.selected_groups[block];
      if (!selected_group) return;

      const data = {
        block: block,
        group: selected_group,
      };

      axios.post(`/customer/${this.customer.id}/add_dot`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        } else {
          this.msgwindow.success('Grupo Añadido');
        }
      }).catch((error) => {
        this.msgwindow.error('No pude añadir el grupo. Consulta con el Administrador');
      }).then(() => {
        this.getCustomerDOTs();
        this.selected_groups[block] = null;
      });
    },
    insertSelectedTypes(dot) {
      if (this.selected_types.length <= 0) {
        return;
      }

      const components = this.selected_types.map((sel) => {
        return sel.label;
      });

      if (!dot.content || dot.content.trim() == '') {
        dot.content = components.join(',  ');
      } else {
        dot.content = dot.content + ',  ' + components.join(',  ');
      }

      this.selected_types = [];
    },
    getTypesForDOT(dot) {
      const gname = dot.group.toLowerCase();
      return this.dot_types[dot.block][gname];
    },
    dotClick(dot) {
      if (!this.is_editing_dot || (this.is_editing_dot.id != dot.id)) {
        this.is_editing_dot = dot;
        this.selected_types = [];
      }
    },
    getClinicDOTs() {
      axios.get(`/clinic/${this.clinic.id}/dot_types`).then((resp) => {
        this.dot_types = resp.data;
      }).catch((error) => {
        this.msgwindow.error('No pude obtener los tipos DOT. Por favor contacte con el Administrador');
      });
    },
    getCustomerDOTs() {
      axios.get(`/customer/${this.customer.id}/dots`).then((resp) => {
        this.dots = resp.data;
      }).catch((error) => {
        this.msgwindow.error('No pude obtener el DOT. Por favor contacte con el Administrador');
      }).then(() => {
        if (!this.dots.objectives || this.dots.objectives.length == 0) {
          this.getDefaultDOTs();
        }
      });
    },
    getDefaultDOTs() {
      const block = 'objectives';
      const group = 'de TRATAMIENTO';
      const data = {
        block: block,
        group: group,
      };

      axios.post(`/customer/${this.customer.id}/add_dot`, data).then((resp) => {
        if (resp.data.error) {
          this.msgwindow.error(resp.data.error);
        }
      }).catch((error) => {
        this.msgwindow.error('No pude añadir el grupo. Consulta con el Administrador');
      }).then(() => {
        this.getCustomerDOTs();
        this.selected_groups[block] = null;
      });
    }
  },
  mounted() {
    this.getCustomerDOTs();
    this.getClinicDOTs();
  }
}

</script>

<style lang="scss">
.customer-edit-dots {
  padding: 20px 20px 33vh 20px;

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    margin: 0 -15px 0 -15px;
    padding: 15px 0 15px 0;
    box-sizing: border-box;
    width: 100%;
  }

  &__header {
    background-color: var(--theme-grey-bg);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 30px;
    gap: 15px;
    margin-bottom: 15px;
  }

  &__section {
    padding: 15px 0;
  }

  &__group {
    padding: 7.5px 15px;
  }

  h2 {
    font-weight: bold;
    font-size: 22px;
    margin: 0;
  }

  h3 {
    font-weight: bold;
    font-size: 18px;
    transition: .3s;
    margin-bottom: 15px;

    i {
      opacity: 0;
      color: var(--theme-color);
      transition: .3s;
    }
  }


  &__group:not(.is-editing) {
    cursor: pointer;
  }


  &__group.is-editing h3 {
    color: var(--theme-color);
  }

  &__group:not(.is-editing):hover {
    h3 {
      color: var(--theme-color);

      i {
        opacity: 1;
      }
    }
  }
}
</style>
